<template>
    <iframe 
        id="completeYourRegistration" 
        class="iframeSel"
        :src="ruta" 
        @load="onLoad = true; $emit('resizeIframe'); $emit('changeLoadingStep', false);"
        :style="{ width: '100%', minHeight: `${windowHeight}px`, heigh: 'auto', display: onLoad ? 'block' : 'none' }"
    ></iframe>
</template>

<script>
import { mapState } from 'vuex';
import PaymentService from "@/services/PaymentService";
import LocalStorageService from "@/services/LocalStorageService";

export default {
    data: () => ({
        eventId: 0,
        userId: 0,
        token: '',
        windowHeight: 0,
        onLoad: false
    }),
    computed: {
        ...mapState({
            ruta(state) {
                let url = `/admin/complete-your-registration?eId=${this.eventId}&uId=${this.userId}&token=${this.token}`;
                return state.env.get('VUE_APP_ROOT') + url;
            },
            language(state) {
                return { languageId: state.session.languageId, languageCode: state.session.languageCode };
            },
            languages(state) {
                return state.session.languages;
            }
        })
    },
    mounted() {
        this.eventId = this.$route.query.eId;
        this.userId = this.$route.query.uId;
        this.token = this.$route.query.token;
        this.windowHeight = window.innerHeight;  
    },
    beforeDestroy () {
        PaymentService.hasUnpaidRegistrations().then(response =>{
            if(response.data.success == 1){
                this.hasUnpaidRegistrations = response.data.message;
                this.$store.dispatch('setUnPaidRegistrationAction', this.hasUnpaidRegistrations);
            }else{
                this.$store.dispatch('setUnPaidRegistrationAction', false);
            }
        });
        LocalStorageService.removeItem('registration_legacy');
    },
    watch: {
        language(val) {
            if(this.onLoad && val) {
                let languageId = val.languageId;
                if(!languageId) {
                    languageId = this.languages.find(el => el.languageCode == val.languageCode);
                    languageId = languageId.id;
                }
                document.getElementById("completeYourRegistration").contentWindow.updateLang(languageId);
            }
        }
    }
}
</script>